module.exports = __webpack_public_path__ + "img/newyear.c12179e7.gif";